// Auth
export const LOGIN_USER_ENDPOINT = "/login";
export const FORGOT_PASSWORD_ENDPOINT = "/send/reset/link";
export const RESET_PASSWORD_ENDPOINT = "/update/password";
export const CHECK_RESET_PASSWORD_LINK =
  "/check/reset/password/token/##TOKEN##";
export const LOGOUT_USER_ENDPOINT = "/logout";
export const CHECK_CREATE_PHARMACY_PASSWORD = "/pharmacy/create/password";

// Users
export const GET_LOGIN_USER_ENDPOINT = "/login/user/detail";

// Config
export const GET_PHARMACY_CONFIG_ENDPOINT = "/pharmacy/config/list";

// First Login Tour
export const FIRST_LOGIN_TOUR_ENDPOINT = "/tour/update";

// Pharmacies
export const GET_PHARMACIES_LIST_ENDPOINT = "/pharmacy/list";
export const CREATE_PHARMACY_ENDPOINT = "/pharmacy/create";
export const UPDATE_PHARMACY_ENDPOINT = "/pharmacy/update/{pharmacy_id}";
export const DELETE_PHARMACY_ENDPOINT = "/pharmacy/{pharmacy_id}";

//Staff
export const GET_STAFF_LIST_ENDPOINT = "/staff/list";
export const CREATE_STAFF_ENDPOINT = "/staff/create";
export const UPDATE_STAFF_ENDPOINT = "/staff/update/{staff_id}";
export const DELETE_STAFF_ENDPOINT = "/staff/{staff_id}";

//Surgery
export const GET_SURGERY_LIST_ENDPOINT = "/surgery/list";
export const CREATE_SURGERY_ENDPOINT = "/surgery/create";
export const UPDATE_SURGERY_ENDPOINT = "/surgery/update/{surgery_id}";
export const DELETE_SURGERY_ENDPOINT = "/surgery/{surgery_id}";
export const GET_SINGLE_SURGERY_ENDPOINT = "/surgery/{surgery_id}";
export const GET_SURGERY_NOTE_LIST_ENDPOINT = "/surgery-note/list";
export const CREATE_SURGERY_NOTE_ENDPOINT = "/surgery-note/create";
export const UPDATE_SURGERY_NOTE_ENDPOINT = "/surgery-note/update/{note_id}";
export const GET_SINGLE_SURGERY_NOTE_ENDPOINT = "/surgery-note/{note_id}";
export const DELETE_SURGERY_NOTE_ENDPOINT = "/surgery-note/{note_id}";

//Driver
export const GET_DRIVER_FIELD_ENDPOINT = "/driver/field/list";

//Day List
export const GET_WORKING_DAY_ENDPOINT = "/working/day";

//Group
export const GET_GROUP_LIST_ENDPOINT = "/group/list";
export const CREATE_GROUP_ENDPOINT = "/group/create";
export const UPDATE_GROUP_ENDPOINT = "/group/update/{group_id}";
export const DELETE_GROUP_ENDPOINT = "/group/{group_id}";
export const GET_SINGLE_GROUP_ENDPOINT = "/group/{group_id}";

//Patient Drop-Down list
export const GET_PATIENT_FIELD_ENDPOINT = "/group/unassign/patient";

//Patient
export const GET_PATIENT_LIST_ENDPOINT = "/patient/list";
export const CREATE_PATIENT_ENDPOINT = "/patient/create";
export const UPDATE_PATIENT_ENDPOINT = "/patient/update/{patient_id}";
export const GET_SINGLE_PATIENT_ENDPOINT = "/patient/{patient_id}";
export const DELETE_PATIENT_ENDPOINT = "/patient/{patient_id}";
export const PATIENT_URGENCY_STATUS_CHANGE =
  "/patient/urgency/status/update/{patient_id}";
export const GET_PATIENT_NOTE_LIST_ENDPOINT = "/patient-note/list";
export const CREATE_PATIENT_NOTE_ENDPOINT = "/patient-note/create";
export const UPDATE_PATIENT_NOTE_ENDPOINT = "/patient-note/update/{patient_id}";
export const DELETE_PATIENT_NOTE_ENDPOINT = "/patient-note/{patient_id}";
export const GET_SINGLE_PATIENT_NOTE_ENDPOINT = "/patient-note/{patient_id}";
export const GET_PATIENT_MEDICATION_HISTORY_LIST_ENDPOINT =
  "/patient/medication/history/{patient_id}";

// ** REACT_APP_PHARMSMART_DRUGS_API :- Drug list New Endpoint
export const GET_DRUG_LIST_ENDPOINT = "/drug/list";

//Surgery Drop-Down List
export const GET_SURGERY_FIELD_ENDPOINT = "/surgery/field/list";

//Pharmacy Drop-Down List
export const GET_PHARMACY_FIELD_ENDPOINT = "/pharmacy/config/list";

//Grug Drop-Down List
export const GET_DRUG_FIELD_ENDPOINT = "/drug/field/list";

//Group Drop-Down List
export const GET_GROUP_FIELD_ENDPOINT = "/group/field/list";

//Repeat Order
export const GET_REPEAT_ORDER_LIST_ENDPOINT = "/order/list";
export const CREATE_REPEAT_ORDER_ENDPOINT = "/order/create";
export const UPDATE_REPEAT_ORDER_ENDPOINT = "/order/update/{order_id}";
export const GET_REPEAT_ORDER_SEARCH_ENDPOINT = "/patient/search/{order_id}";
export const GET_SINGLE_REPEAT_ORDER_ENDPOINT = "/order/detail/{order_id}";
export const GET_REPEAT_ORDER_COUNT_ENDPOINT = "/order/count";
export const DELETE_REPEAT_ORDER_ENDPOINT = "/order/delete/{order_id}";
export const UPDATE_REPEAT_ORDER_DATE_ENDPOINT = "/order/update-date";
export const ADD_MEDICATION_PATINET_ENDPOINT = "/patient/add/medication";
export const UPDATE_GLOBAL_SETTING_ENDPOINT = "/general-settings/update/{id}";
export const UPDATE_REPEAT_ORDER_NOTE_ENDPOINT =
  "/order/update-note/{order_id}";
export const DELETE_REPEAT_ORDER_NOTE_ENDPOINT =
  "/order/delete-note/{order_id}";
export const GET_OOS_ORDER_LIST_ENDPOINT = "/order/oos/order/list";
export const GET_GLOBAL_SETTING_ENDPOINT = "/general-settings/list";
export const GET_GLOBAL_SETTING_ACCESS = "/general-settings/access/user/list";

export const CREATE_MULTI_ORDER_ENDPOINT = "/order/create-bulk-reorder";

//Repeat order patient Drop-Down List
export const GET_REPEAT_ORDER_PATIENT_LIST_ENDPOINT = "/patient/field/list";

//Home
export const GET_HOME_LIST_ENDPOINT = "/dashboard/count/list";

//Collection
export const GET_COLLECTION_LIST_ENDPOINT = "/collection/list";
export const GET_COLLECTION_COUNT_ENDPOINT = "/collection/count/list";
export const DELETE_COLLECTION_ENDPOINT = "/collection/delete/{collection_id}";
export const GET_COLLECTION_DETAIL_ENDPOINT =
  "/collection/detail/{collection_id}";
export const UPDATE_COLLECT_DATA_ENDPOINT =
  "/collection/update/{collection_id}";
export const UPDATE_ADD_AND_UPDATE_NOTE_ENDPOINT =
  "collection/update/note/{collection_id}";
export const DELETE_NOTE_ENDPOINT = "/collection/delete/note/{collection_id}";
export const GET_CREATE_RX_ENDPOINT = "/collection/create";
export const UPDATE_CHASEUP_ENDPOINT = "/chase-up/reopen/{collection_id}";

//OrderPad
export const GET_REPEATORDER_TO_ORDERPAD_ENDPOINT = "/collection/view/orderpad";
export const GET_CREATE_ORDERPAD_ENDPOINT = "/order/create-collection";
export const GET_CREATE_TODAY_ORDERPAD_ENDPOINT = "/order/create/for-today";
export const COLLECT_AND_REMOVE_ENDPOINT =
  "collection/collected-or-remove/{collection_id}";
export const COLLECTED_AND_REMOVED_ENDPOINT =
  "/collection/collected-or-removed/{collection_id}";
export const COLLECT_MARK_AS_URGENT_ENDPOINT =
  "collection/update/urgent-flag/{collection_id}";

export const ACTIVITY_LOG_ENDPOINT = "user-activity/list";

export const STAFF_SEARCH_ENDPOINT = "staff/field/list";

// simulator
export const CREATE_SIMULATOR_ENDPOINT = "simulator";

//Patient Count
export const COUNT_PATIENT_ENDPOINT = "check-patient/{type}/{id}";

//No of Alert on Dashboard
export const GET_NO_OF_ALERT_ENDPOINT = "/order/alert";

//Import CSV File in pateint
export const IMPORT_CSV_ENDPOINT = "/patient/imports";

//CSv File List
export const IMPORT_CSV_LIST_ENDPOINT = "/temp-patient/list";
export const DELETE_MULTIPLE_AND_SINGLE_CSV_LIST_ENDPOINT =
  "/temp-patient/delete";

export const STATUS_ENDPOINT = "/patient/status/update/{id}";

export const UPDATE_SURGERY_FIELD_ENDPOINT = "/surgery/update/field/{id}";

export const UPDATE_PATIENT_FIELD_ENDPOINT = "/patient/update/field/{id}";

export const UPDATE_DRUG_NAME_ENDPOINT = "/medication/update/{id}";

export const UPDATE_PRN_ENDPOINT = "/patient/medication/update/prn";

export const ORDER_SPEED = "/dashboard/orders/speed";

export const CHASEUP_CHART = "/dashboard/chaseup/chart";

export const ORDER_CHART = "/dashboard/box/count/list";

export const CREATE_SURGERY_MULTIPLE = "/surgery/multiple/create";

export const ARCHIVE_COLLECTION = "/collection/archive";

export const COMPLETE_COLLECTION = "/collection/status/update";

export const ARCHIVE_MEDICATION = "/patient/medication/update/status/{id}";

export const GROUP_ORDER_DATE = "/group/update/order-date/{id}";

export const REFRESHTOKEN = "/refresh-token";

export const PROFILEUPDATE = "/profile/update";

export const PAYMENT_CREATE = "/payment/create";

export const PAYMENT_LINK_CREATE = "/payment/link/create";

export const PAYMENT_LIST = "/payment/list";

export const PATIENT_CREATE_MULTIORDER = "/patient/create/multiple/order";

export const NEXT_CYCLE_DAY = "/order/next/date";

export const PATIENT_DELETE_MULTIPLE = "/patient/delete";

export const IMPORT_PATIENT_DUPLICATE = "/duplicate-patient/list";

export const IMPORT_DELETE_DUPLICATE = "/duplicate-patient/delete";

export const ORDER_COUNT_TYPE = "/order/type/count";

export const SUBSCRIPTION_CREATE = "/subscription/create";

export const SUBSCRIPTION_CANCEL = "/subscription/cancel";

export const SUBSCRIPTION_UPDATE = "/subscription/update";

export const PATIENT_DELETE_COUNT = "/patient/count/delete";

// Mohit work start
// Create_Nursing api
export const Create_Nursing = "/nursing/create";
export const GET_NURSING_LIST = "/nursing/list";
export const DELETE_NURSING_LIST = "nursing/";
export const GET_SINGLE_NURSING_LIST = "/nursing/detail/";
export const UPDATE_NURSING_LIST = "/nursing/update/";

export const ASSIGN_NURSING = "/nursing/assigned/patient";
export const PATIENTS_DATA = "/nursing/patient/list/";

export const EMAIL_LINK = "/nursing/assigned/patient-list";
export const ADD_PATIENT = "/nursing/added/patient";

export const Medication_List = "/patient/medication/list";

export const Get_Today_List_Count = "/order/today-list-count";
export const Get_Today_List = "/order/today-list";
export const Create_Bulk_Order_Today = "/order/create-bulk-today";
